<template>
  <img
    :key="imageKey"
    :src="url"
    :alt="alt"
    class="markdown-image"
    :class="{ 'image-layout-single': imageLayout === 'single' }"
    loading="eager"
    decoding="async"
  />
</template>

<script>
export default {
  name: "MarkdownImage",
  props: {
    url: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "",
    },
    // 图片布局：'grid' 一行三张 1:1；'single' 一行一张不固定宽高比（由 MarkdownText 传入）
    imageLayout: {
      type: String,
      default: "grid",
      validator: (v) => ["grid", "single"].includes(v),
    },
  },
  computed: {
    // 使用 URL 生成稳定的 key，确保 Vue 能正确识别和复用图片元素
    imageKey() {
      return `img-${this.url}`;
    },
  },
};
</script>

<style scoped>
.markdown-image {
  width: calc(33.333% - 4px);
  aspect-ratio: 1 / 1;
  object-fit: cover;
  display: inline-block;
  vertical-align: top;
  margin: 2px;
  box-sizing: border-box;
  border-radius: 4px;
}

/* 相关问题回复：一行一个，不固定宽高比 */
.markdown-image.image-layout-single {
  width: 100%;
  aspect-ratio: auto;
  object-fit: contain;
  display: block;
  margin: 8px 0;
}
</style>
